import { DATABASE_OPTIMIZATION_FEATURE_KEY } from './database-optimization/constants';

/**
 * Maps platform usage unit enum values from the billing API to human-readable
 * labels. Unknown values pass through unchanged; empty/undefined → ''.
 */
const PLATFORM_USAGE_UNIT_LABELS: Record<string, string> = {
  cpu: 'cpu',
  database_instance: 'database instances',
};

export const getUnitLabel = (unit?: string): string =>
  unit ? PLATFORM_USAGE_UNIT_LABELS[unit.toLowerCase()] ?? unit : '';

/**
 * Sorts platform usage features alphabetically by displayName, with the
 * Database Optimization feature always pinned last.
 */
export const sortPlatformUsageFeatures = <
  T extends { feature?: string; displayName?: string }
>(
  features: T[]
): T[] =>
  [...features].sort((a, b) => {
    const aIsDbo = a.feature === DATABASE_OPTIMIZATION_FEATURE_KEY;
    const bIsDbo = b.feature === DATABASE_OPTIMIZATION_FEATURE_KEY;
    if (aIsDbo !== bIsDbo) return aIsDbo ? 1 : -1;
    return (a.displayName ?? a.feature ?? '').localeCompare(
      b.displayName ?? b.feature ?? ''
    );
  });
